import script from "./income.vue?vue&type=script&setup=true&lang=js"
export * from "./income.vue?vue&type=script&setup=true&lang=js"

import "./income.vue?vue&type=style&index=0&id=53edb7b5&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53edb7b5"]])

export default __exports__